import React, { SyntheticEvent, useState } from 'react';
import { Tooltip } from 'antd';
import { useDispatch } from 'react-redux';
import { TooltipPlacement } from 'antd/es/tooltip';
import { toggleBillingModal } from '@redux/actions/modalAction';
import './UpgradePlanTooltip.less';

function UpgradePlanTooltip({
  children,
  text,
  isCanVisible,
  innerStyle,
  isShowUpgradeText = true,
  beforeUpgradeClick,
  getPopupContainer,
  placement,
  upgradeStyle
}: {
  children: React.ReactChildren | React.ReactChild;
  text: string;
  isShowUpgradeText?: boolean;
  isCanVisible: boolean;
  innerStyle?: any;
  upgradeStyle?: React.CSSProperties;
  placement?: TooltipPlacement;
  getPopupContainer?: (triggerNode: HTMLElement) => HTMLElement;
  beforeUpgradeClick?(
    e: SyntheticEvent<HTMLSpanElement, MouseEvent>
  ): void | false;
}) {
  const dispatch = useDispatch();
  const [isVisibleToolTip, setIsVisibleTooltip] = useState(false);

  return (
    <Tooltip
      open={isVisibleToolTip}
      onOpenChange={(visible) => setIsVisibleTooltip(isCanVisible && visible)}
      trigger="hover"
      autoAdjustOverflow={true}
      placement={placement || 'top'}
      overlayClassName="upgrade-plan-tooltip"
      overlayInnerStyle={innerStyle}
      getPopupContainer={getPopupContainer}
      title={
        <div>
          {isShowUpgradeText && (
            <>
              <span
                style={{
                  textDecoration: 'underline',
                  cursor: 'pointer',
                  ...upgradeStyle
                }}
                onClick={(e) => {
                  const shouldOpenBillingModal =
                    beforeUpgradeClick?.(e) !== false && !e.defaultPrevented;

                  if (!shouldOpenBillingModal) {
                    return;
                  }

                  dispatch(toggleBillingModal({ visible: true }));
                }}
              >
                Upgrade
              </span>{' '}
            </>
          )}
          {text}
        </div>
      }
    >
      {children}
    </Tooltip>
  );
}

export default UpgradePlanTooltip;
